import crudFactory from "../crudFactory.ts";

const MODEL = "widget-orchestrator/orchestrator";

const COMMON_CRUD_APIs = crudFactory(MODEL);

export default { ...COMMON_CRUD_APIs };
